import { ReactNode } from "react";
import ReactSelect from "react-select";
import styled from "styled-components";

export default styled(ReactSelect).attrs<ISelectProps>(
    (props) => (
        {
            onChange(option: IOption) {
                props.onSelect(option.value);
            },
            value: props.options.find(
                (option) => option.value === props.value
            ),
        }
    )
)``;

interface IOption {
    label: ReactNode
    value: unknown
}

interface ISelectProps {
    onSelect: (value: unknown) => void
    options: IOption[]
    value: unknown
}
